(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const editorMode = window.Shopify?.designMode || document.documentElement.classList.contains('theme-editor');

  function remap(value, from, to) {
    if (to <= from) return value >= from ? 1 : 0;
    return Math.min(1, Math.max(0, (value - from) / (to - from)));
  }

  function apply(el) {
    const target = el.querySelector('[data-benefit-reveal]') || el;
    const rect = target.getBoundingClientRect();
    const vh = window.innerHeight;
    const start = vh * 0.92;
    const end = vh * 0.32;
    const progress = Math.min(1, Math.max(0, (start - rect.top) / (start - end)));

    el.style.setProperty('--reveal', progress.toFixed(4));
    el.style.setProperty('--p-number', remap(progress, 0.15, 0.35).toFixed(4));
    el.style.setProperty('--p-title', remap(progress, 0.35, 0.55).toFixed(4));
    el.style.setProperty('--p-desc', remap(progress, 0.55, 0.75).toFixed(4));
  }

  function setImmediate(el) {
    el.style.setProperty('--reveal', '1');
    el.style.setProperty('--p-number', '1');
    el.style.setProperty('--p-title', '1');
    el.style.setProperty('--p-desc', '1');
  }

  const init = (scope = document) => {
    const stories = [...scope.querySelectorAll('[data-benefit-story]')];
    if (!stories.length) return;

    if (editorMode || reducedMotion.matches) {
      stories.forEach(setImmediate);
      return;
    }

    let rafId = null;
    const onScroll = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        stories.forEach(apply);
      });
    };

    stories.forEach(apply);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  init();
})();
